/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext } from 'react';
import { Collapse, Table, Badge } from 'reactstrap';

// local imports
import { ThemeContext } from '../../contexts/ThemeContext';


const Clients = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [isClientOpen, setIsClientOpen] = useState(true);


    // utility functions
    const toggleClient = () => setIsClientOpen(!isClientOpen)

    // function's return
    return (

        <div className="p-3 mt-3" style={theme.card} key={props.index}>
            <div className="row px-3" onClick={toggleClient} style={{ cursor: "pointer" }}>
                <span style={theme.headingBold}>{props.client.clientId.firstName} {props.client.clientId.lastName}</span>
                {props.newClientAdded.includes(props.client.clientId.email) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                <span className="ml-auto" style={theme.headingRegular}>

                    {
                        isClientOpen
                            ? <span className="ml-3"><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-3"><i className="fas fa-angle-down"></i></span>
                    }
                </span>
            </div>

            <Collapse isOpen={isClientOpen}>
                <hr />
                <div className="row">
                    <div className="col-sm-3 col-md-3 text-center">
                        <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                            <img className="m-auto w-100 h-100" src={props.client.clientId.profileImage} alt="My client" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                        </div>
                    </div>

                    <div className="col-sm-9 col-md-9">
                        <Table borderless>
                            <tbody>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Unique id</span>
                                    </td>
                                    <td>
                                        <span>{props.client._id}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Sessions Done</span>
                                    </td>
                                    <td>
                                        <span>{props.client.sessionsDone}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Email</span>
                                    </td>
                                    <td>
                                        <span>{props.client.clientId.email}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Phone</span>
                                    </td>
                                    <td>
                                        <span>{props.client.clientId.phone}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Gender</span>
                                    </td>
                                    <td>
                                        <span style={{ textTransform: "capitalize" }}>{props.client.clientId.gender}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <span style={{ color: "#007bff", cursor: "pointer" }} onClick={props.openFormResponses}>View form responses</span>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Collapse>


        </div>
    )

}

export default Clients;